/**
 * BBE – BOGO Mousse LP runtime
 * Handles: bundle selection, shade selection, cart operations (clear → add → discount),
 * pre-purchase upsell modal gate, shade quiz lightbox.
 * Self-contained; does not share state with lp-clean-glow-bogo-std.js.
 */

(function () {
  'use strict';

  if (window.__bbeLpBogoMousseLoaded) return;
  window.__bbeLpBogoMousseLoaded = true;

  // ─── STATE ───────────────────────────────────────────────────────────────────
  var curBundle = 2;       // default to BOGO (option 2)
  var curShade  = '';
  var atcNavPending = false;
  var LP_ATC_OFFER_LABEL = 'CLAIM OFFER';
  var LP_AJAX_CART_SILENT_OPTS = { info: { should_keep_drawer_closed: true } };

  // ─── ROOT ────────────────────────────────────────────────────────────────────
  function getRoot() {
    return document.querySelector('[data-mousse-lp-root]') || document;
  }

  // ─── BUNDLE DATA ─────────────────────────────────────────────────────────────
  function getBundleEl(idx) {
    return getRoot().querySelector('[data-mousse-bundle="' + idx + '"]');
  }

  function getBundleData(idx) {
    var el = getBundleEl(idx);
    if (!el) return null;
    return {
      qty:      Math.max(1, parseInt(el.dataset.qty || '1', 10) || 1),
      discount: (el.dataset.discount || '').trim()
    };
  }

  // ─── VARIANT ID ──────────────────────────────────────────────────────────────
  function getVariantId(shade) {
    var el = getRoot().querySelector('[data-mousse-shade="' + shade + '"]');
    if (!el) return null;
    var id = (el.dataset.variantId || '').trim();
    return id && /^\d+$/.test(id) ? id : null;
  }

  // ─── FALLBACK URL ────────────────────────────────────────────────────────────
  function buildFallbackCartURL() {
    var bundle    = getBundleData(curBundle);
    var variantId = getVariantId(curShade);
    if (!bundle || !variantId) return null;
    var qs = bundle.discount ? '?discount=' + encodeURIComponent(bundle.discount) : '';
    return '/cart/' + variantId + ':' + bundle.qty + qs;
  }

  function getMousseCheckoutUrl() {
    var modal = document.querySelector('pre-upsell-modal');
    return (modal && modal.dataset.checkoutUrl) || '/checkout';
  }

  function syncMousseAtcCopy() {
    var root = getRoot();
    var sel = root.querySelector('[data-mousse-bundle].m-bopt--sel .m-bopt__price-now');
    var price = sel ? sel.textContent.trim() : '';
    var label = price ? LP_ATC_OFFER_LABEL + ' • ' + price : LP_ATC_OFFER_LABEL;
    root.querySelectorAll('[data-mousse-atc]').forEach(function (btn) {
      var svg = btn.querySelector('svg');
      btn.textContent = '';
      btn.appendChild(document.createTextNode(label));
      if (svg) {
        btn.appendChild(document.createTextNode(' '));
        btn.appendChild(svg);
      }
      btn.setAttribute('aria-label', label);
    });
  }

  // ─── SYNC STICKY LABELS ──────────────────────────────────────────────────────
  function syncStickyLabels() {
    var root = getRoot();
    // Find section ID from sticky bar element
    var stickyEl = root.querySelector('.m-sticky[id]');
    if (!stickyEl) return;
    var sid = (stickyEl.id || '').replace('m-sticky-', '');
    if (!sid) return;

    var bundleLbl = document.getElementById('sticky-bundle-lbl-' + sid);
    if (bundleLbl) {
      var selBopt = root.querySelector('[data-mousse-bundle].m-bopt--sel .m-bopt__name');
      if (selBopt) bundleLbl.textContent = selBopt.textContent.trim();
    }

    var shadeLbl = document.getElementById('sticky-shade-lbl-' + sid);
    var sep = stickyEl.querySelector('.m-sticky__sel-sep');
    if (shadeLbl) {
      var selShade = root.querySelector('[data-mousse-shade].m-shade--sel .m-shade__name');
      shadeLbl.textContent = selShade ? selShade.textContent.trim() : '';
    }
    if (sep) sep.style.display = shadeLbl && shadeLbl.textContent ? '' : 'none';
  }

  // ─── SELECT BUNDLE ───────────────────────────────────────────────────────────
  function selectBundle(idx) {
    curBundle = idx;
    var root = getRoot();
    root.querySelectorAll('[data-mousse-bundle]').forEach(function (b) {
      b.classList.remove('m-bopt--sel');
    });
    var el = getBundleEl(idx);
    if (el) el.classList.add('m-bopt--sel');
    // Update savings display
    var savings = el && (el.dataset.savings || '').trim();
    if (savings) {
      var savEl = root.querySelector('.m-savings-bar__num');
      if (savEl) savEl.textContent = savings;
    }
    syncStickyLabels();
    syncMousseAtcCopy();
  }

  // ─── SELECT SHADE ────────────────────────────────────────────────────────────
  function selectShade(shade) {
    curShade = shade;
    var root = getRoot();
    root.querySelectorAll('[data-mousse-shade]').forEach(function (s) {
      s.classList.remove('m-shade--sel');
    });
    var el = root.querySelector('[data-mousse-shade="' + shade + '"]');
    if (el) el.classList.add('m-shade--sel');
    syncMousseShadeGuide(root);
    syncStickyLabels();
  }

  function syncMousseShadeGuide(root) {
    root = root || getRoot();
    var guide = root.querySelector('.js-lp-shade-guide');
    if (!guide) return;
    var hasSelection = Boolean(root.querySelector('[data-mousse-shade].m-shade--sel'));
    guide.classList.toggle('lp-shade-guide--hidden', hasSelection);
    guide.setAttribute('aria-hidden', hasSelection ? 'true' : 'false');
  }

  // ─── PRE-UPSELL GATE ─────────────────────────────────────────────────────────
  function isPreUpsellEnabled() {
    return Boolean(
      getRoot().querySelector('.lp-bogo-mousse-pre-upsell-flag[data-enable-pre-upsell="true"]')
    );
  }

  var LP_PRE_UPSELL_ADD_SELECTOR =
    '.pre-upsell__item:not(.added):not(.pre-upsell__item--market-hidden):not([hidden]) button[data-upsell-add]:not([disabled])';

  function resolveLpPreUpsellCheckout(modal) {
    if (typeof window.bbeResolvePreUpsellCheckout === 'function') {
      return window.bbeResolvePreUpsellCheckout(modal);
    }
    if (!(modal instanceof Element)) return Promise.resolve({ action: 'skip' });
    return Promise.resolve({
      action: modal.querySelector(LP_PRE_UPSELL_ADD_SELECTOR) ? 'open' : 'skip',
    });
  }

  function skipLpPreUpsellToCheckout(checkoutUrl) {
    if (typeof window.bbeSkipPreUpsellToCheckout === 'function') {
      window.bbeSkipPreUpsellToCheckout(checkoutUrl);
      return;
    }
    window.location.assign(checkoutUrl || '/checkout');
  }

  // ─── CART OPS ────────────────────────────────────────────────────────────────
  function prepareMousseCart() {
    var bundle    = getBundleData(curBundle);
    var variantId = getVariantId(curShade);
    if (!bundle || !variantId) {
      return Promise.reject(new Error('[lp-bogo-mousse] Missing variant or bundle data'));
    }
    var headers  = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var discount = bundle.discount;

    if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === 'function') {
      return new Promise(function (resolve, reject) {
        var settled = false;
        var timer = window.setTimeout(function () {
          if (settled) return;
          settled = true;
          reject(new Error('cart add timed out'));
        }, 12000);
        window.liquidAjaxCart.add(
          { items: [{ id: Number(variantId), quantity: bundle.qty }] },
          Object.assign({}, LP_AJAX_CART_SILENT_OPTS, {
            lastCallback: function (state) {
                  if (settled) return;
                  if (!state || !state.responseData || !state.responseData.ok) {
                    settled = true;
                    clearTimeout(timer);
                    reject(new Error('cart add failed'));
                    return;
                  }
                  if (!discount || typeof window.liquidAjaxCart.update !== 'function') {
                    settled = true;
                    clearTimeout(timer);
                    resolve();
                    return;
                  }
                  window.liquidAjaxCart.update(
                    { discount: discount },
                    {
                      lastCallback: function () {
                        if (settled) return;
                        settled = true;
                        clearTimeout(timer);
                        resolve();
                      }
                    }
                  );
                }
              })
            );
          });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: headers,
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: bundle.qty }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        return res.json();
      })
      .then(function (json) {
        if (json && json.status) throw new Error(json.description || 'cart add failed');
        if (!discount) {
          if (window.liquidAjaxCart && typeof window.liquidAjaxCart.update === 'function') {
            return new Promise(function (resolve) {
              window.liquidAjaxCart.update({}, { lastCallback: function () { resolve(); } });
            });
          }
          return;
        }
        return fetch('/discount/' + encodeURIComponent(discount), { credentials: 'same-origin' })
          .catch(function () { return null; })
          .then(function () {
            if (window.liquidAjaxCart && typeof window.liquidAjaxCart.update === 'function') {
              return new Promise(function (resolve) {
                window.liquidAjaxCart.update(
                  { discount: discount },
                  { lastCallback: function () { resolve(); } }
                );
              });
            }
          });
      });
  }

  // ─── ATC LOADING STATE ───────────────────────────────────────────────────────
  function setAtcLoading(loading) {
    getRoot().querySelectorAll('[data-mousse-atc]').forEach(function (btn) {
      btn.classList.toggle('is-loading', loading);
      if (loading) {
        btn.setAttribute('disabled', '');
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-busy');
      }
    });
  }

  // ─── ATC HANDLER ─────────────────────────────────────────────────────────────
  function handleAtc(e) {
    if (atcNavPending) return;
    var invoker   = e && e.currentTarget ? e.currentTarget : null;
    var bundle    = getBundleData(curBundle);
    var variantId = getVariantId(curShade);

    if (!bundle || !variantId) {
      alert('Please select a shade. If the issue persists, contact support.');
      return;
    }

    var preUpsellModal = document.querySelector('pre-upsell-modal');

    if (isPreUpsellEnabled() && preUpsellModal) {
      atcNavPending = true;
      setAtcLoading(true);

      prepareMousseCart()
        .then(function () {
          return resolveLpPreUpsellCheckout(preUpsellModal);
        })
        .then(function (outcome) {
          if (outcome && outcome.action === 'open') {
            var doOpen = function () {
              if (typeof preUpsellModal.open === 'function') {
                preUpsellModal.open(invoker || null);
              }
            };
            if (typeof preUpsellModal.open === 'function') {
              doOpen();
            } else {
              customElements.whenDefined('pre-upsell-modal').then(doOpen);
            }
            atcNavPending = false;
            setAtcLoading(false);
          } else {
            var checkoutUrl = (preUpsellModal.dataset.checkoutUrl) || '/checkout';
            skipLpPreUpsellToCheckout(checkoutUrl);
          }
        })
        .catch(function (err) {
          console.warn('[lp-bogo-mousse] Pre-upsell flow failed; routing to checkout', err);
          atcNavPending = false;
          setAtcLoading(false);
          skipLpPreUpsellToCheckout(getMousseCheckoutUrl());
        });

      return;
    }

    atcNavPending = true;
    setAtcLoading(true);
    prepareMousseCart()
      .then(function () {
        window.location.assign(getMousseCheckoutUrl());
      })
      .catch(function () {
        atcNavPending = false;
        setAtcLoading(false);
        skipLpPreUpsellToCheckout(getMousseCheckoutUrl());
      });
  }

  // ─── QUIZ ─────────────────────────────────────────────────────────────────────
  function quizWinnerFromTally(T) {
    var keys = ['light', 'medium', 'dark'];
    keys.sort(function (a, b) {
      if (T[b] !== T[a]) return T[b] - T[a];
      var pref = { medium: 0, light: 1, dark: 2 };
      return pref[a] - pref[b];
    });
    return keys[0];
  }

  function clampQuizWinnerToCeiling(rawWinner, ceilingRaw) {
    var c = String(ceilingRaw || '').trim().toLowerCase();
    var w = String(rawWinner  || '').trim().toLowerCase();
    if (!w) return 'medium';
    if (c === 'medium' && w === 'dark') return 'medium';
    if (c === 'light'  && (w === 'dark' || w === 'medium')) return 'light';
    return w;
  }

  function initShadeQuizForLb(lb) {
    if (!lb || lb.dataset.mousseQuizBound === '1') return;
    lb.dataset.mousseQuizBound = '1';

    // Extract section ID from lightbox element ID: "lp-shade-quiz-lb-{SECTIONID}"
    var sid = (lb.id || '').replace('lp-shade-quiz-lb-', '');

    // Parse config JSON
    var cfg = {};
    var cfgEl = document.getElementById('lp-shade-quiz-config-' + sid);
    if (!cfgEl) {
      var allCfgEls = document.querySelectorAll('script[type="application/json"][id^="lp-shade-quiz-config-"]');
      cfgEl = allCfgEls.length ? allCfgEls[0] : null;
    }
    if (cfgEl && cfgEl.textContent) {
      try { cfg = JSON.parse(cfgEl.textContent); } catch (_e) { cfg = {}; }
    }

    // Element refs (use section-id-suffixed IDs, fall back to class selectors)
    var closeX    = lb.querySelector('#lp-shade-quiz-lb-x-' + sid) || lb.querySelector('.shade-quiz-lb__x');
    var backBtn   = lb.querySelector('#lp-shade-quiz-lb-back-' + sid) || lb.querySelector('.shade-quiz-lb__back');
    var progFill  = lb.querySelector('#lp-shade-quiz-lb-progress-fill-' + sid) || lb.querySelector('.shade-quiz-lb__progress-fill');
    var progLabel = lb.querySelector('#lp-shade-quiz-lb-progress-label-' + sid) || lb.querySelector('.shade-quiz-lb__progress-label');
    var stepEls   = lb.querySelectorAll('[data-lb-step]');

    // Radio field names (snippet appends section.id)
    var fieldByStep = [
      null,
      'sq_burn_' + sid,
      'sq_freckle_' + sid,
      'sq_tone_' + sid,
      'sq_eyes_' + sid,
      'sq_hair_' + sid
    ];
    var FIRST_STEP = 1;
    var step = FIRST_STEP;
    var lastFocus = null;
    var suppressAdvance = false;

    // Apply quiz result to page
    function applyResult() {
      var T = { light: 0, medium: 0, dark: 0 };
      fieldByStep.forEach(function (name) {
        if (!name) return;
        var inp = lb.querySelector('input[name="' + name + '"]:checked');
        if (inp && T[inp.value] !== undefined) T[inp.value] += 1;
      });
      var winnerRaw = quizWinnerFromTally(T);
      var ceiling   = String(cfg.quizShadeCeiling || '').trim().toLowerCase();
      var winner    = clampQuizWinnerToCeiling(winnerRaw, ceiling);

      var pool = (cfg.variants || []).filter(function (x) { return x.tier === winner; });
      var v    = pool.find(function (x) { return x.img; }) || pool[0];
      var res  = cfg.results && cfg.results[winner];
      var heroUrl = ((res && res.hero_image && String(res.hero_image).trim()) || (v && v.img) || '');

      var titleEl  = lb.querySelector('#lp-shade-quiz-result-title-' + sid)  || lb.querySelector('.shade-quiz-lb__result-title');
      var imgEl    = lb.querySelector('#lp-shade-quiz-result-img-' + sid)     || lb.querySelector('.shade-quiz-lb__result-variant');
      var imgWrap  = lb.querySelector('#lp-shade-quiz-result-img-wrap-' + sid)|| lb.querySelector('.shade-quiz-lb__result-img-wrap');
      var copyEl   = lb.querySelector('#lp-shade-quiz-result-copy-' + sid)    || lb.querySelector('.shade-quiz-lb__result-copy');

      if (titleEl) titleEl.textContent = (v && v.title) || winner;
      if (imgEl) {
        if (heroUrl) {
          imgEl.src = heroUrl;
          imgEl.alt = (v && v.title) || '';
          imgEl.hidden = false;
          if (imgWrap) imgWrap.hidden = false;
        } else {
          imgEl.removeAttribute('src');
          imgEl.hidden = true;
          if (imgWrap) imgWrap.hidden = true;
        }
      }
      if (copyEl) copyEl.innerHTML = (res && res.copy) || '';

      // Before/after images
      var ba    = (cfg.ba && cfg.ba[winner]) || {};
      var bbEl  = lb.querySelector('#lp-shade-quiz-ba-before-' + sid);
      var baftEl= lb.querySelector('#lp-shade-quiz-ba-after-' + sid);
      var baBox = lb.querySelector('#lp-shade-quiz-result-ba-' + sid);
      if (bbEl) {
        var fig1 = bbEl.closest('figure');
        if (ba.before) { bbEl.src = ba.before; if (fig1) fig1.style.display = ''; }
        else { bbEl.removeAttribute('src'); if (fig1) fig1.style.display = 'none'; }
      }
      if (baftEl) {
        var fig2 = baftEl.closest('figure');
        if (ba.after) { baftEl.src = ba.after; if (fig2) fig2.style.display = ''; }
        else { baftEl.removeAttribute('src'); if (fig2) fig2.style.display = 'none'; }
      }
      if (baBox) baBox.style.display = (ba.before || ba.after) ? 'grid' : 'none';

      // Sync shade selection on the main page
      if (v && v.shade) selectShade(v.shade);
    }

    function setProgress() {
      var pct = step >= 1 && step <= 5 ? Math.round((step / 6) * 100) : step === 6 ? 100 : 0;
      if (progFill)  progFill.style.width = pct + '%';
      if (progLabel) {
        if (step >= 1 && step <= 5) progLabel.textContent = 'Question ' + step + ' of 5';
        else if (step === 6)        progLabel.textContent = 'Your match';
        else                        progLabel.textContent = '';
      }
    }

    function setStep(n) {
      step = n;
      var sheet = lb.querySelector('.shade-quiz-lb__sheet');
      var body  = lb.querySelector('.shade-quiz-lb__body');
      if (sheet) sheet.scrollTop = 0;
      if (body)  body.scrollTop  = 0;
      stepEls.forEach(function (el) {
        var sn = parseInt(el.getAttribute('data-lb-step'), 10);
        var on = sn === n;
        el.classList.toggle('is-active', on);
        el.hidden = !on;
      });
      if (backBtn) backBtn.hidden = step <= FIRST_STEP || step === 6;
      setProgress();
      if (step === 6) {
        var resEl = lb.querySelector('[data-lb-step="6"]');
        if (resEl) resEl.focus();
      }
    }

    function resetQuiz() {
      suppressAdvance = true;
      lb.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = false; });
      step = FIRST_STEP;
      setStep(FIRST_STEP);
      suppressAdvance = false;
    }

    function validateCurrent() {
      if (step === 6) return true;
      var name = fieldByStep[step];
      if (!name) return true;
      return !!lb.querySelector('input[name="' + name + '"]:checked');
    }

    function advanceAfterAnswer() {
      if (suppressAdvance || lb.hidden) return;
      if (step < FIRST_STEP || step > 5) return;
      if (!validateCurrent()) return;
      if (step === 5) { applyResult(); setStep(6); return; }
      setStep(step + 1);
    }

    function openLb() {
      lastFocus = document.activeElement;
      lb.hidden = false;
      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('lp-shade-quiz-lb-open');
      resetQuiz();
    }
    lb.__lpOpenShadeQuiz = openLb;

    function closeLb() {
      lb.hidden = true;
      lb.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('lp-shade-quiz-lb-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    // Close triggers
    lb.querySelectorAll('[data-shade-quiz-lb-close]').forEach(function (el) {
      el.addEventListener('click', closeLb);
    });
    if (closeX) closeX.addEventListener('click', closeLb);

    // Back button
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (step > FIRST_STEP) setStep(step - 1);
      });
    }

    // Click on option → auto-advance
    lb.addEventListener('click', function (e) {
      var opt = e.target && e.target.closest ? e.target.closest('.shade-quiz-lb__opt') : null;
      if (!opt || !lb.contains(opt) || suppressAdvance) return;
      if (step < FIRST_STEP || step > 5) return;
      var expectedName = fieldByStep[step];
      if (!expectedName) return;
      var radio = opt.querySelector('input[type="radio"]');
      if (!radio || radio.name !== expectedName) return;
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      advanceAfterAnswer();
    });

    // Change event → auto-advance
    lb.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio' || !lb.contains(t) || suppressAdvance) return;
      if (step < FIRST_STEP || step > 5) return;
      var expectedName = fieldByStep[step];
      if (!expectedName || t.name !== expectedName) return;
      advanceAfterAnswer();
    });

    // Retry button
    var retryBtn = lb.querySelector('.js-shade-quiz-retry');
    if (retryBtn) retryBtn.addEventListener('click', resetQuiz);

    // Select-shade CTA (result screen)
    lb.addEventListener('click', function (e) {
      var sel = e.target && e.target.closest ? e.target.closest('.js-shade-quiz-select-shade') : null;
      if (!sel || !lb.contains(sel) || step !== 6) return;
      e.preventDefault();
      applyResult();
      closeLb();
    });

    // Escape closes
    document.addEventListener('keydown', function (e) {
      if (lb.hidden || e.key !== 'Escape') return;
      e.preventDefault();
      closeLb();
    });
  }

  // Global click handler for .js-shade-quiz-open
  var quizOpenBound = false;
  function bindQuizOpenOnce() {
    if (quizOpenBound) return;
    quizOpenBound = true;
    document.addEventListener('click', function (e) {
      var opener = e.target && e.target.closest ? e.target.closest('.js-shade-quiz-open') : null;
      if (!opener) return;
      e.preventDefault();
      var lb = document.querySelector('[data-bbe-quiz-root]');
      if (lb && typeof lb.__lpOpenShadeQuiz === 'function') {
        lb.__lpOpenShadeQuiz();
      } else {
        var fb = (opener.getAttribute('data-shade-quiz-fallback-url') || '').trim();
        if (fb) window.location.assign(fb);
      }
    }, true);
  }

  function initQuizAll() {
    bindQuizOpenOnce();
    document.querySelectorAll('[data-bbe-quiz-root]').forEach(initShadeQuizForLb);
  }

  // ─── INIT ─────────────────────────────────────────────────────────────────────
  function init() {
    var root = getRoot();

    // Bundle selection
    root.querySelectorAll('[data-mousse-bundle]').forEach(function (el) {
      el.addEventListener('click', function () {
        selectBundle(parseInt(el.dataset.mousseBundle, 10) || 1);
      });
    });

    // Shade selection
    root.querySelectorAll('[data-mousse-shade]').forEach(function (el) {
      el.addEventListener('click', function () {
        selectShade(el.dataset.mousseShade);
      });
    });

    // ATC buttons
    root.querySelectorAll('[data-mousse-atc]').forEach(function (btn) {
      btn.addEventListener('click', handleAtc);
    });

    // Quiz
    initQuizAll();

    // Seed bundle from pre-selected DOM
    var selBundle = root.querySelector('[data-mousse-bundle].m-bopt--sel');
    if (selBundle) curBundle = parseInt(selBundle.dataset.mousseBundle, 10) || 2;

    // Default the shade to Medium (first match) so there is no unselected state
    var preShade = root.querySelector('[data-mousse-shade].m-shade--sel');
    if (!preShade) {
      var allShades = Array.prototype.slice.call(root.querySelectorAll('[data-mousse-shade]'));
      preShade = allShades.filter(function (s) {
        return /medium/i.test(s.dataset.mousseShade || '');
      })[0] || allShades[0] || null;
    }
    if (preShade) selectShade(preShade.dataset.mousseShade);

    syncStickyLabels();
    syncMousseAtcCopy();
    syncMousseShadeGuide(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
